// extracted by mini-css-extract-plugin
module.exports = {"close_btn":"styles_close_btn__1y2dG","close_btn__icon":"styles_close_btn__icon__3-tH6"};